export default "__VITE_PUBLIC_ASSET__68911849__"